/**
 * Styles for CampaignCarousel component
 */
export const styles = {
  carouselWrapper: {
    width: '100%',
    maxWidth: '1000px',
    position: 'relative',
    overflow: 'hidden',
    '&:focus': {
      outline: 'none',
    },
  },
  scrollContainer: {
    display: 'flex',
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollBehavior: 'smooth',
    maxWidth: '1000px',
    minHeight: '130px',
    // Hide scrollbar
    scrollbarWidth: 'none', // Firefox
    '&::-webkit-scrollbar': {
      display: 'none', // Chrome, Safari, Opera
    },
    // Snap scrolling for better UX
    scrollSnapType: 'x mandatory',
    '@media screen and (max-width: 768px)': {
      maxWidth: '100%',
    },
  },
  // Left fade only - mask applied to wrapper (masks children)
  fadeLeft: {
    maskImage:
      'linear-gradient(to right, transparent 0%, black 100px, black 100%)',
    WebkitMaskImage:
      'linear-gradient(to right, transparent 0%, black 100px, black 100%)',
    '@media screen and (max-width: 768px)': {
      maskImage: 'none',
      WebkitMaskImage: 'none',
    },
  },
  // Right fade only - mask applied to wrapper (masks children)
  fadeRight: {
    maskImage:
      'linear-gradient(to left, transparent 0%, black 100px, black 100%)',
    WebkitMaskImage:
      'linear-gradient(to left, transparent 0%, black 100px, black 100%)',
    '@media screen and (max-width: 768px)': {
      maskImage: 'none',
      WebkitMaskImage: 'none',
    },
  },
  // Both fades - when in middle pages
  fadeBoth: {
    maskImage:
      'linear-gradient(to right, transparent 0%, black 100px, black calc(100% - 100px), transparent 100%)',
    WebkitMaskImage:
      'linear-gradient(to right, transparent 0%, black 100px, black calc(100% - 100px), transparent 100%)',
    '@media screen and (max-width: 768px)': {
      maskImage: 'none',
      WebkitMaskImage: 'none',
    },
  },
  cardsContainer: {
    display: 'flex',
    gap: '20px',
    alignItems: 'stretch',
    height: '120px',
    '@media screen and (max-width: 768px)': {
      height: 'calc-size(fit-content, size + 15px);',
      gap: '0',
      width: '100%',
    },
  },
  cardWrapper: {
    flex: '0 0 auto',
    width: '420px',
    display: 'flex',
    // Make all cards same height - fixed to accommodate all content
    '& > *': {
      width: '100%',
      minHeight: '150px',
      display: 'flex',
      flexDirection: 'column',
    },
    '@media screen and (max-width: 768px)': {
      width: '100%',
    },
  },
  // Desktop: group 2 cards horizontally per page
  desktopPageGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    flex: '0 0 auto',
    scrollSnapStop: 'always',
  },
  // Mobile: group 2 cards vertically per page
  mobilePageGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    flex: '0 0 auto',
    scrollSnapStop: 'always',
    width: '100%', // Use container width, not viewport width
    boxSizing: 'border-box',
    // Nested card wrappers should be full width
    '& > div': {
      width: '100%',
      flex: '0 0 auto',
    },
  },
}

/**
 * Styles for CarouselIndicators component
 */
export const indicatorStyles = {
  indicators: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  arrowButton: {
    width: '40px',
    height: '40px',
    border: 'none',
    background: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    padding: 0,
    '& svg': {
      fontSize: '24px',
      color: '#374151',
    },
    '&:hover:not(:disabled)': {
      background: '#F9FAFB',
    },
    '&:active:not(:disabled)': {
      transform: 'scale(0.96)',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  arrowButtonDisabled: {
    opacity: 0.4,
    cursor: 'not-allowed',
    background: '#F9FAFB',
    borderColor: '#E5E7EB',
    '& svg': {
      color: '#9CA3AF',
    },
  },
  dotsContainer: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
    padding: '0 8px',
  },
  dot: {
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    border: 'none',
    background: '#BEBED6',
    cursor: 'pointer',
    transition: 'all 0.25s ease',
    padding: 0,
    '&:hover': {
      background: '#2E3860',
      transform: 'scale(1.15)',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  dotActive: {
    background: '#374151',
    width: '12px',
    borderRadius: '4px',
    outline: 'none',
  },
}
